import React, { useEffect, useState } from "react";
import "./CartProductCard.css";
import { faAngleRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import IncrementDecrementBtn from "../../common_components/Increment_Decrement_Btn/Increment_Decrement_Btn";
import { getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

const CartProductCard = ({ saveTotal, customClass, ...props }) => {
  const allCart = useSelector((state) => state.cart.allCarts);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();

  // useEffect(() => {
  //     dispatch(getAllCart(isSignIn));
  // }, []);

  const [totalSaving, setTotalSaving] = useState();
  const [totaAmount, setTotalAmount] = useState();
  const [count, setCount] = useState();
  const inCart = useSelector((state) => state.cart.checkItem);

  return (
    <div className="CartProductCard">
      <div className="product_content">
        <div className="product_detail_inner">
          <div className="row row_class">
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8">
              <div className="left_side">
                <div className="img_holder">
                  <img src={process.env.REACT_APP_IMG_URL + props?.img} />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{props?.title}</p>
                  </div>
                  <div className="weight">
                    <p>
                      {props?.cartVarient?.Product_Variant?.name}{" "}
                      {props?.cartVarient?.Product.Unit?.name}
                    </p>
                  </div>
                  <div className="price_section">
                    <div className="selling_price">
                      <p>
                        ₹
                        {Number(
                          props?.cartVarient?.Product_Variant?.price || 0
                        ).toFixed(2)}
                      </p>
                    </div>

                    <div className="mrp">
                      <p>
                        ₹
                        {Number(
                          props?.cartVarient?.Product_Variant?.mrp || 0
                        ).toFixed(2)}
                      </p>
                    </div>
                  </div>

                  {/* <div className="price_section">
                    <div className="selling_price">
                      <p>₹ {props?.cartVarient?.Product_Variant?.price}</p>
                    </div>

                    <div className="mrp">
                      <p>₹ {props?.cartVarient?.Product_Variant?.mrp}</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-4">
              <div className="right_side">
                <IncrementDecrementBtn
                  varientId={props?.cartVarient?.Product_Variant?.id}
                  cart={allCart?.data?.data}
                  varient={props?.cartVarient?.Product_Variant}
                  product={props?.cartVarient?.Product}
                  productId={props?.cartVarient?.product_id}
                  isSignIn={isSignIn}
                  totalSaving={totalSaving}
                  setTotalSaving={setTotalSaving}
                  totaAmount={totaAmount}
                  setTotalAmount={setTotalAmount}
                  saveTotal={saveTotal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartProductCard;
